import React, { FC } from 'react';
import icons from '../../../icons';
import './EditorBackButton.css';

interface EditorBackButtonProps {
  goBack: () => void;
  disabled: boolean;
}

export const EditorBackButton: FC<EditorBackButtonProps> = ({ goBack, disabled }) => {

  return (
    <button
      className="editor-back-button"
      onClick={goBack}
      disabled={disabled}
    >
      <i className={icons.back}></i>
      Back
    </button>
  );
};